import * as yup from 'yup';

const validationSchema = formatMessage =>
  yup.object().shape({
    industry: yup.object().required(
      formatMessage({
        id: 'REQUIRED_SERVICE_DIRECTORY_INDUSTRY',
        defaultMessage: 'Industry is required',
      }),
    ),
    address: yup.string().required(
      formatMessage({
        id: 'REQUIRED_SERVICE_DIRECTORY_ADDRESS',
        defaultMessage: 'Address is required',
      }),
    ),
    problem: yup.string().nullable(),
  });

export default validationSchema;
